import classNames from 'classnames';
import { Icon } from 'palette/Icon';
import { Small } from 'palette/Typography';

import '../styles/Sizes.scss';

interface SizesProps {
    sizes: string[];
    maxNumberOfSizes?: number;
    isInline?: boolean;
    className?: string;
}

function SizeList({
    sizes = [],
    maxNumberOfSizes = 5,
    isInline = false,
    className = '',
}: SizesProps) {
    const hasToDisplayPlusSign = sizes.length > maxNumberOfSizes;
    return (sizes.length > 0 ? (
        <div className={classNames('palette-product-card-size-list', className, {
            'palette-product-card-size-list--inline': isInline,
            'palette-product-card-size-list--block': !isInline,
        })}
        >
            {
                sizes.slice(0, maxNumberOfSizes).map(size => (
                    <Small
                        key={size}
                        className="palette-product-card-size-list__item"
                        color="light"
                        level="2"
                    >
                        {size}
                    </Small>
                ))
            }
            {
                hasToDisplayPlusSign
                && (
                    <Icon
                        className="palette-product-card-size-list__icon"
                        name="palette_plus"
                        size="xxx-small"
                    />
                )
            }
        </div>
    ) : null);
}

export default SizeList;
